
import { Component, Vue, Prop } from 'vue-property-decorator';
import DropZone from '@/components/UI/DropZone.vue';
import Icon from '@/components/UI/Icon.vue';
import { JobComplianceHiddenData } from '@/models/JobComplianceTypes';
import { uuidv4 } from '@/utils/Common';
import { FileExtended } from '@/models/jobTicket';

@Component({
  components: {
    DropZone,
    Icon,
  },
})
export default class JobAttachmentsField extends Vue {
  @Prop({ type: Object, required: false, default: false }) public jobHiddenData: JobComplianceHiddenData;

  public deleteFiles(id: string | number): void {
    const fileToUploadIdx = this.jobHiddenData.filesToUpload.findIndex(x => x.id === id);
    if (fileToUploadIdx >= 0) {
      this.jobHiddenData.filesToUpload.splice(fileToUploadIdx, 1);
      this.$forceUpdate();
    }
  }

  public filesAdded(files: FileExtended[]): void {
    if (files.length > 0) {
      files.map(file => {
        const newFile = {
          id: uuidv4(),
          uploaded_by: '',
          file: file.name,
          created_at: '',
          file_data: file,
        };
        this.jobHiddenData.filesToUpload.push(newFile);
      });
      this.$forceUpdate();
    }
  }
}
